(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
(function ($) {

	// Original Accordion
	$.fn.accordion = function () {

		this.find('.title').on('click', function () {

			$(this).parent().find('.body').slideToggle();
			$(this).parent().toggleClass('-open');

		})

	}

	// Toggle Class
	$.fn.accordionToggle = function () {

		this.find('[data-accordion-id]').on('click', function (e) {
			e.preventDefault();

			// Get Id
			var id = $(this).data('accordionId');

			// Remove All Active
			$(this).parent().parent().find('.-active').removeClass('-active');

			// Set Active
			$('[data-accordion-target="' + id + '"]').addClass('-active');
			$(this).addClass('-active');
			setTimeout(function () {
				$('[data-accordion-target="' + id + '"] .body-wrap').addClass('-active')
			}, 50)

		})

	}



}(jQuery));

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/accordion.js","/modules")